import React from "react";
import image1 from "../../images/INSIGHTS-ANALYTICS.jpg";
import image2 from "../../images/Showcase-local-events.jpg";
import image3 from "../../images/Grow-your-community.jpg";

const Twocolumn = () => {
  return (
    <section id="feature" className="twocolumn">
      <div className="container">
        <div className="twocolumn-row">
          <div className="col-50">
            <div className="image">
              <img src={image1} alt="INSIGHTS & ANALYTICS" />
            </div>
          </div>
          <div className="col-50">
            <div className="content">
              <label>INSIGHTS & ANALYTICS</label>
              <h2>Showcase your Business </h2>
              <p>
                Present your amazing products and services to the locals around
                you.
              </p>
            </div>
          </div>
        </div>
        <div className="twocolumn-row">
          <div className="col-50">
            <div className="image">
              <img src={image2} alt="INSIGHTS & ANALYTICS" />
            </div>
          </div>
          <div className="col-50">
            <div className="content">
              <label>DRIVE IN-STORE SALES & TRAFFIC</label>
              <h2>Create exclusive deals</h2>
              <p>Creative impactful deals to pull in more customers.</p>
            </div>
          </div>
        </div>
        <div className="twocolumn-row">
          <div className="col-50">
            <div className="image">
              <img src={image3} alt="INSIGHTS & ANALYTICS" />
            </div>
          </div>
          <div className="col-50">
            <div className="content">
              <label>INTERACT WITH THE COMMUNITY</label>
              <h2>Host events and activities</h2>
              <p>
                Host fun and engaging events and let the locals know about them.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Twocolumn;
